/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dateto1Inputs */

const en_dateto1 = /** @type {(inputs: Dateto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const de_dateto1 = /** @type {(inputs: Dateto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Dateto1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dateto1 = /** @type {((inputs?: Dateto1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dateto1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dateto1(inputs)
	return de_dateto1(inputs)
});
export { dateto1 as "dateTo" }